
const BUILDER_Z_INDEX = Object.freeze({
  CANVAS_CONTENT: 0,

  GPU_EDIT_CHROME: 100,
  GPU_REGION_DEFAULT: 100,
  GPU_MINIMAP: 110,
  GPU_INSPECTOR_TOGGLE: 120,

  BREAKPOINT_RULER: 140,

  CANVAS_CONTROLS: 150,

  FLOATING_PALETTE: 160,
  FLOATING_PALETTE_RESIZE: 170,
  GPU_LAYERS_OVERLAY: 180,

  BOTTOM_SHEET: 200,
  DRAWER: 1000,

  BUILDER_POPUP: 2000,

  FLOATING_WINDOW: 9000,

  PRESENCE_CURSOR: 9500,

  MODAL: 9999,
  TOOLTIP: 99999,
  DRAG_GHOST: 10500,
});

module.exports = BUILDER_Z_INDEX;
